const PENDING_POST_CALL_JOIN_KEY = 'videocall.pendingPostCallJoin';
const MAX_AGE_MS = 30 * 60 * 1000;

type PendingPostCallJoin = {
  callSessionId: string;
  inviteToken: string;
  serverUrl: string;
  createdAt: number;
};

export function setPendingPostCallJoin(data: {
  callSessionId: string;
  inviteToken: string;
  serverUrl: string;
}) {
  const payload: PendingPostCallJoin = {
    callSessionId: String(data.callSessionId || '').trim(),
    inviteToken: String(data.inviteToken || '').trim(),
    serverUrl: String(data.serverUrl || '').trim(),
    createdAt: Date.now()
  };

  if (!payload.callSessionId || !payload.inviteToken || !payload.serverUrl) return;

  try {
    sessionStorage.setItem(PENDING_POST_CALL_JOIN_KEY, JSON.stringify(payload));
  } catch {
    // ignore
  }
}

export function consumePendingPostCallJoin(callSessionId: string): { inviteToken: string; serverUrl: string } | null {
  try {
    const raw = sessionStorage.getItem(PENDING_POST_CALL_JOIN_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as Partial<PendingPostCallJoin>;

    const expectedCallSessionId = String(parsed.callSessionId || '').trim();
    const inviteToken = String(parsed.inviteToken || '').trim();
    const serverUrl = String(parsed.serverUrl || '').trim();
    const createdAt = Number(parsed.createdAt || 0);

    const isExpired = !createdAt || Date.now() - createdAt > MAX_AGE_MS;
    const isSameCall = expectedCallSessionId && expectedCallSessionId === String(callSessionId || '').trim();

    if (!isSameCall || isExpired || !inviteToken || !serverUrl) {
      sessionStorage.removeItem(PENDING_POST_CALL_JOIN_KEY);
      return null;
    }

    sessionStorage.removeItem(PENDING_POST_CALL_JOIN_KEY);
    return { inviteToken, serverUrl };
  } catch {
    return null;
  }
}
